import { Box, Stack, Typography } from '@mui/material';
import { NablaLogo } from 'assets/images';
import { Outlet } from 'react-router-dom';
import ja from 'utils/ja';

const AuthLayout = () => {
  return (
    <Box sx={{ height: '100dvh' }}>
      <Box
        sx={{
          textAlign: 'left',
          padding: { xs: '45px 41px 0', sm: '85px 81px 0' },
        }}
      >
        <Box
          component='img'
          src={NablaLogo}
          sx={{ width: { xs: '254px', sm: '314px' }, objectFit: 'contain' }}
        />
      </Box>
      <Stack
        justifyContent='center'
        alignItems='center'
        sx={{ width: '100%', height: 'calc(100% - 146px)' }}
      >
        <Typography
          sx={{
            color: '#1a96f0',
            fontSize: { xs: '36px !important', sm: '50px !important' },
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '27px',
          }}
        >
          {ja.common.title}
        </Typography>
        <Outlet />
      </Stack>
    </Box>
  );
};

export default AuthLayout;
